var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartStraightBreak = function SvgIconHeartStraightBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.034 2.75a5.88 5.88 0 0 0-4.316 1.718l-.003.002-.715.72-.519-.522-.004-.005C9.279 2.476 5.61 2.09 3.204 4.253a5.875 5.875 0 0 0-.237 8.529l7.791 7.79.004.004a1.76 1.76 0 0 0 2.476 0l-.704-.71.707.707 7.594-7.594.002-.002c2.187-2.198 2.574-5.866.41-8.273a5.87 5.87 0 0 0-4.213-1.953m2.385 8.817-7.42 7.419-7.617-7.618a3.88 3.88 0 0 1 .157-5.626l.001-.002c1.511-1.359 3.973-1.203 5.524.339l.555.559-.857.937a1 1 0 0 0 .03 1.382l2.294 2.293-.793.793a1 1 0 0 0 1.414 1.414l1.5-1.5a1 1 0 0 0 0-1.414l-2.324-2.324.845-.924 1.404-1.413a3.874 3.874 0 0 1 5.626.157l.001.002c1.36 1.511 1.204 3.973-.34 5.525",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeartStraightBreak;